import { createFileRoute } from "@tanstack/react-router";

import { SignupForm } from "@/features/auth/ui";

export const Route = createFileRoute("/_public/signup")({
  component: () => (
    <div className="flex min-h-svh w-full items-center justify-center overflow-y-hidden p-6 md:p-10">
      <div className="w-full max-w-sm">
        <SignupForm />
      </div>
    </div>
  ),
});
